<template>
  <el-dialog :visible.sync="updateProductDiglog" width="95%" :show-close="false" :offset="0" class="updateProductDiglog">
    <div style="padding-top:0.2rem;font-size:0.12rem;color: black;">
      <label class="planInfo">日期及行程</label>
      <label style="width: 2%;display: inline-block;">项目</label>
      <label style="width: 13%;display: inline-block;text-align: center;">产品名称</label>
      <label style="width: 13.5%;%;display: inline-block;text-align: center;">产品说明</label>
      <label style="width: 3.5%;display: inline-block;">库存单位</label>
      <label style="width: 3.5%;display: inline-block;">使用时长</label>
      <label style="width: 3.5%;display: inline-block;">使用数量</label>
      <label style="width: 3.5%;display: inline-block;">单项成本</label>
      <label style="width: 4%;display: inline-block;">单项报价</label>
      <label style="width: 3.8%;display: inline-block;">单项利润</label>
      <label style="width: 3.4%;display: inline-block;">总成本</label>
      <label style="width: 2.9%;display: inline-block;">总报价</label>
      <label style="width: 2.9%;display: inline-block;">总利润</label>
      <label style="width: 3.5%; display: inline-block;text-align: center;">利润率</label>
      <label style="width: 2.3%;display: inline-block;">汇率</label>
      <label style="width: 4.7%;display: inline-block;">总成本(￥)</label>
      <label style="width: 4.7%;display: inline-block;">总报价(￥)</label>
      <label style="width: 4%;display: inline-block;">总利润(￥)</label>
      <label style="width: 4%;display: inline-block;">产品状态</label>
    </div>
    <div v-if="updateProductDataList.length">
      <div class="daybox" v-for="(item,index) in updateProductDataList" :key="index">
        <div class="dayboxzoom" style="padding: 0.05rem;width: 10%;">
          <label>{{dateFormatYMD(item.planDate,".")}}&nbsp;</label>
          <label>
            <span v-for="(item1,index1) in item.cityList" :key="index1">{{item1.cityName}}
              <span v-if="(index1!=item.cityList.length-1)">-</span>
            </span>
          </label>
        </div>
        <div style="margin-top:0.05rem;margin-bottom: 0.05rem;width:89%">
          <draggable v-model="item.productList" group="itxst" animation="300" @add="addCommand" @start="onStart">
            <transition-group :style="style" :id="item.planDate">
              <div v-for="(item1,index1) in item.productList" :key="item.planDay+'-'+index1" class="productBox" :id="item1.id" 
                :stockId="item1.stockId" :productType="item1.productType" :budgetId="item1.budgetId">
                <label style="width:2.7%;padding-left: 0.05rem;" class="label">{{item1.budgetType}}</label>
                <label style="width:15%;padding-left: 0.05rem;" class="label">{{item1.productName}}</label>
                <label class="productDesc">{{item1.stockDetailObj.productDesc}}</label>
                <label style="width:4.2%;" class="label center">{{item1.stockDetailObj.priceList?item1.stockDetailObj.priceList[0].priceCompany:''}}</label>
                <label style="width:4.3%" class="label center">{{item1.stockDetailObj.priceList?item1.stockDetailObj.priceList[0].useTime:''}}</label>
                <label style="width:3.5%" class="label center">{{item1.stockNumber}}</label>
                <label style="width:4.3%" class="label center">{{item1.stockPrice}}{{item1.currency}}</label>
                <label style="width:4.3%" class="label center">{{item1.ratio}}{{item1.currency}}</label>
                <label style="width:4.3%" class="label center">{{item1.ratio-item1.stockPrice}}{{item1.currency}}</label>
                <label style="width:3.8%" class="label center">{{item1.stockPrice*item1.stockNumber}}{{item1.currency}}</label>
                <label style="width:3.8%" class="label center">{{item1.ratio*item1.stockNumber}}{{item1.currency}}</label>
                <label style="width:3.2%" class="label center">{{(item1.ratio-item1.stockPrice)*item1.stockNumber}}{{item1.currency}}</label>
                <label style="width:4%" class="label center">
                  {{Number((((item1.ratio-item1.stockPrice)*item1.stockNumber)/item1.ratio*100).toFixed(2))}}%
                </label>
                <label style="width:2.5%" class="label center">{{item1.rate}}</label>
                <label style="width:5%" class="label center">{{Number((item1.stockPrice*item1.stockNumber*item1.rate).toFixed(2))}}</label>
                <label style="width:5%" class="label center">{{Number((item1.ratio*item1.stockNumber*item1.rate).toFixed(2))}}</label>
                <label style="width:5%" class="label center">{{Number(((item1.ratio-item1.stockPrice)*item1.stockNumber*item1.rate).toFixed(2))}}</label>
                <a style="width: 3%" @click="handleDelete(2,item1,item.productList)" class="label center">删除</a>
                <a style="width:3%;color:#B4B2B2" class="label center" @click="recoverData(item1,item)" v-if="item1.stockStatus===2">恢复</a>
                <label style="width:3%" class="label center" v-else>有效</label>
              </div>
            </transition-group>
          </draggable>
        </div>  
      </div>
    </div>
    <div v-else></div> 
    <div style="justify-content: center;display: flex;padding-bottom: 10px;">
      <div style="width: 2.3rem;">
        <el-button @click="saveMove()" class="savebuttom">保存</el-button>
        <el-button @click="closeDialog()" class="savebuttom" style="margin-left:75px;">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import {stockTypeMap} from '@/assets/utils/commonData'
import draggable from 'vuedraggable'
import Api from '@/components/Api/index.js'
import { refresh } from '../../js/function'
export default {
  components:{draggable},
  data(){
    return{
      updateProductDiglog:false,
      updateProductDataList:[],
      stockTypeMap,
      style: "min-height:20px;display: block;",
      oldProductList:[],
      checkBudget:null,
      uuid:'',
      refeshObj:null,
    }
  },
  methods:{
    closeDialog(){
      this.updateProductDiglog=false
      if(this.refeshObj){
        refresh(this.refeshObj,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
      }
    },
    saveMove(){
      if(this.uuid!=''){
        new PlanApi('plan').changeBudgetStayDate({key:this.uuid}).then(res => {
          if (res.status == 200) {
            this.refeshObj = res.data
            this.$message({ type: "success",message: "保存成功"}); 
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }
    },
    handleDelete (index, row,arr) {
      this.$confirm('此操作将会永久删除该数据不可恢复，您确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').budgetDelete({
          budgetMainId:[this.checkBudgetDetail.budgetMainId],
          budgetDetailIds:[row.id],
          budgetIds:[row.budgetId]
        }).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"删除成功"})
            arr.splice(index,1)
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
    recoverData(item1,item){
      this.addNewProductList(item1.id,item.planDate,item1.productType,item1.stockId,item1.budgetId)
    },
    addCommand(e){
      var attributes = e.item.attributes;
      var stockId =null;
      if(attributes.stockId){
        stockId = attributes.stockId.value
      }
      var id = e.item.id
      this.addNewProductList(id,e.to.id,attributes.productType.value,stockId,attributes.budgetId.value)
    },
    onStart(e){
      this.oldProductList = JSON.parse(JSON.stringify(this.updateProductDataList))
    },
    addNewProductList(id,stayDate,productType,stockId,budgetId){
      new Api('resource').changeStockDate({
        productType:productType,
        addFlag:this.uuid,
        id:id,
        stockId:stockId,
        budgetId:budgetId,
        stayDate:stayDate
      }).then(res => {
        if (res.status == 200) {
          this.uuid = res.data;        
          if(id){
            var productList =[];
            this.updateProductDataList.forEach(item=>{
              productList = [...productList,...item.productList]
            })
            var obj = productList.find(p=>p.id == id);
            obj.stockStatus = 1;
          }
        }else{
          this.updateProductDataList = this.oldProductList;
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    openDialog(data){
      this.checkBudget = data
      this.updateProductDiglog = true
      this.updateProductDataList = []
      this.newProductList = []
      new PlanApi('plan').budgetDetailList({budgetMainId:data.id,showSpot:2}).then(res => {
        if (res.status == 200) {
          data.planDayList.forEach(element => {
            var productList = []
            res.data.budgetList.forEach(ee=>{
              if(ee.day==element.planDay){
                ee.stockDetailObj = ee.stockDetail?JSON.parse(ee.stockDetail):{}
                ee.budgetType = this.stockTypeMap[ee.state].typeName
                productList.push(ee)
              }       
            })
            this.$set(element,'productList',productList)
            this.updateProductDataList.push(element)
          });
          console.log('sx',this.updateProductDataList)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.updateProductDiglog {
  font-weight: bold;
  font-size: 0.12rem;
  /deep/ .el-dialog__body{
    background-color: #F7F7F7;
  }
  /deep/ .el-dialog__header{
    padding: 0 !important;
  }
  .savebuttom{
    background-color: #E64A19;
    color: white;
    width: 0.65rem;
    display: inline-flex;
    justify-content: center;
    height: 0.4rem;
    align-items: center;
    border-radius: 10px;
  }
  .planInfo{
    color:#E64A19;
    width: 10%;
    display: inline-block;
    text-align: center;
    margin-left:0.1rem;
  }
  .daybox{
    background-color: white;
    margin: 0.1rem;    
    display: flex;
    color: black;
    font-size: 0.12rem;
  }
  .productDesc{
    width:14%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    align-self: center;
    display: block;
    padding-left: 0.05rem;
  }
  .productBox{
    margin-top: 0.05rem;
    margin-bottom: 0.05rem;
    height: 0.38rem;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.18);
    display: flex;
    .center{
      display: flex;
      justify-content: center;
    }
    .label{
      display: flex;
      height: 100%;
      align-items: center;
    }
  }
}
</style>